import {cookie} from "./lib/cookie.js";
import {dialog} from "./lib/dialog.js"
import {request} from "./lib/request.js"
import {log} from "./lib/log.js"
import {position} from "./lib/positionFn.js"
import {url} from "./lib/url.js"
import {simpleDate} from "./lib/simpleDate.js"
import {requestSign} from "./lib/requestSign.js"
import {share} from "./lib/share.js"
import {browser} from './lib/browser'
import cityInfo from './lib/cityInfo'
import sa from "./lib/TCSensors.js"

export default {
  install: function (vm) {
    vm.prototype.cookie = cookie;
    vm.prototype.dialog=dialog;
    vm.prototype.request=request;
    vm.prototype.url=url;
    vm.prototype.simpleDate=simpleDate;
    vm.prototype.log=log;
    // vm.prototype.getLocation=getLocation.getLocation;
    vm.prototype.requestSign=requestSign;
    vm.prototype.position=position;
    vm.prototype.share=share;//分享页面
    // Vue.prototype.$moment = moment
    vm.prototype.browser=browser;
    vm.prototype.cityInfo=cityInfo;
    vm.prototype.sa=sa;
  }
};





// WEBPACK FOOTER //
// ./static/js/utils.js